<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h4>
                    <i class="fas fa-history"></i> Convivência Familiar e
                    Comunitária
                </h4>
                <div>
                    <button
                        class="btn active btn-outline-secondary btn-sm"
                        title="Voltar para Identificação da Família e Endereço"
                        @click="$emit('voltar')"
                    >
                        <i class="mdi mdi-arrow-left"></i>Voltar
                    </button>
                </div>
            </div>
        </div>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div
            class="col-md-6 mb-3"
            v-for="convivencia in convivencias"
            :key="convivencia.id"
        >
            <div class="card border">
                <div class="card-header bg-gray">
                    <p>
                        Data: <b>{{ convivencia.created_at || formatDate }}</b>
                    </p>
                    <p>
                        Técnico: <b>{{ convivencia.user_id }}</b>
                    </p>
                </div>
                <div class="card-body">
                    <p>
                        <b>Há quantos anos a família mora no bairro atual</b>
                        {{ convivencia.qtd_mora_bairro }}
                    </p>
                    <p>
                        <b>Há quantos anos a família mora neste estado</b>
                        {{ convivencia.qtd_mora_estado }}
                    </p>
                    <p>
                        <b>Há quantos anos a família mora no município</b>
                        {{ convivencia.qtd_mora_municipio }}
                    </p>
                    <p>
                        <b
                            >Indique se há relações conflituosas envolvendo
                            outros indivíduos que residam no domicílio? :</b
                        >
                        {{
                            verificarResposta(
                                convivencia.relacoes_conflituosas_outros,
                                $root.arrays.relacoes_conflituosas_outros
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Percepção/Avaliação do técnico sobre as relações
                            entre os irmãos, se for o caso:</b
                        >
                        {{
                            verificarResposta(
                                convivencia.relacoes_entre_irmaos,
                                $root.arrays.relacoes_conjugais_familia
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Percepção/Avaliação do técnico sobre as relações
                            conjugais na família, se for o caso</b
                        >
                        {{
                            verificarResposta(
                                convivencia.relacoes_conjugais,
                                $root.arrays.relacoes_conjugais_familia
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Percepção/Avaliação do técnico sobre as relações
                            entre pais/responsáveis e os filhos inclusive entre
                            o padrasto ou madrasta com o(s) enteados(as), se for
                            o caso:</b
                        >
                        {{
                            verificarResposta(
                                convivencia.relacoes_responsaveis,
                                $root.arrays.relacoes_conjugais_familia
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >A família possui parentes que residam próximo ao
                            seu local de moradia e que constituam rede de apoio
                            e solidariedade?:</b
                        >
                        {{ pergunta(convivencia.apoio_parentes) }}
                    </p>
                    <p>
                        <b
                            >A família, ou algum de seus membros, participa de
                            grupos religiosos, comunitários ou outros
                            grupos/instituições que constituam rede de apoio e
                            solidariedade?</b
                        >
                        {{ pergunta(convivencia.apoio_grupo_comunitario) }}
                    </p>
                    <p>
                        <b
                            >A família possui vizinhos que constituam rede de
                            apoio e solidariedade?</b
                        >
                        {{ pergunta(convivencia.apoio_vizinhos) }}
                    </p>
                    <p>
                        <b
                            >Existe alguma criança ou adolescente do grupo
                            familiar que não tem acesso a atividades de lazer,
                            recreação e convívio social?</b
                        >
                        {{
                            verificarResposta(
                                convivencia.cri_ado_acesso_lazer,
                                $root.arrays.pergunta_cri_ado_acesso_lazer
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >A família, ou algum de seus membros, é vítima de
                            ameaças ou de discriminação na comunidade onde
                            reside?:</b
                        >
                        {{ pergunta(convivencia.discriminacao_convivencia) }}
                    </p>
                    <p>
                        <b
                            >A família, ou algum de seus membros, participa de
                            movimentos sociais, sindicatos, organizações
                            comunitárias, Conselhos ou quaisquer outras ações ou
                            instituições voltadas para organização política e
                            defesa de interesses coletivos?</b
                        >
                        {{ pergunta(convivencia.grupos_sociais_defesa) }}
                    </p>
                    <p>
                        <b
                            >Existe alguma pessoa idosa do grupo familiar que não tem
                            acesso a atividades de lazer, recreação e convívio
                            social?</b
                        >
                        {{ pergunta(convivencia.idoso_acesso_lazer) }}
                    </p>
                    <p>
                        <b
                            >Há pessoas dependentes (crianças, pessoas idosas
                            dependentes ou pessoas com deficiência) que
                            permanecem períodos do dia em casa sem a companhia
                            de um adulto?</b
                        >
                        {{
                            verificarResposta(
                                convivencia.dependente_cuidados,
                                $root.arrays.pergunta_dependente_cuidados
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Outras observações referentes ao diagnóstico das
                            condições de convivência familiar e comunitária:</b
                        >
                        {{ convivencia.observavoes_comunitaria }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Read",
    props: ["familiaId"],
    data() {
        return {
            loading: true,
            convivencias: {},
        };
    },
    mounted() {
        this.getconvivencia();
    },
    methods: {
        getconvivencia() {
            axios
                .get(
                    "api/dashboard/familias/historico/convivencia/" +
                        this.familiaId
                )
                .then((response) => {
                    this.convivencias = response.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.$router.push(
                        "/dashboard/familias/edit/" +
                            this.familiaId +
                            "/identificacao"
                    );
                });
        },
        dateConverter(date) {
            if (date) {
                return moment(date).format("DD/MM/YYYY");
            } else {
                return "";
            }
        },
        pergunta(item) {
            var value = item == 1 ? 0 : 1;
            return this.$root.arrays.pergunta[value].value;
        },
        verificarResposta(resposta, array) {
            const result = array.filter((item) => item.id == resposta);
            return result[0] ? result[0].value : "";
        },
    },
};
</script>
